<!--
  +---------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备增值-收费方案详情-基本信息
  +---------------------------------------------------------------------------------------
-->

<template>
  <div v-loading="loading" class="ei-scheme-basic">
    <div class="toolbox">
      <el-button v-show="!postFormShow" type="primary" @click="setScheme">设置方案信息</el-button>
    </div>
    <el-form v-show="!postFormShow" ref="displayForm" class="display-form" label-position="left" label-width="120px" :model="profile">
      <el-form-item label="方案类型">
        <span v-if="profile.scheme_unit === 'year'">年收费方案</span>
        <span v-if="profile.scheme_unit === 'month'">月收费方案</span>
        <span v-if="profile.scheme_unit === 'once'">一次性收费方案</span>
      </el-form-item>
      <el-form-item label="方案名称">
        <span>{{ profile.title }}</span>
      </el-form-item>
      <el-form-item>
        <span slot="label">
          <span class="mr-xs">收费标准</span>
          <el-tooltip placement="top" popper-class="price_tooltip">
            <span slot="content">
              请注意，该收费标准将作为定价参考，实际售价还受商户促销、平台营销，以及是否涉及物联卡保号复机等因素影响。最终收费标准，以下单时页面展示为准。
            </span>
            <i class="iconfont icon-circle-question" style="font-size: 14px;color: #999;"></i>
          </el-tooltip>
        </span>
        <span v-if="profile.scheme_price">{{ profile.scheme_price | currency }}</span>
      </el-form-item>
      <el-form-item :class="profile.activity_enable&&'begin'" label="活动信息">
        <span v-if="!profile.activity_enable">无</span>
        <el-form v-else class="activity" label-position="left" label-width="80px">
          <el-form-item label="活动名称">
            <span v-if="profile.activity_params.title">{{ profile.activity_params.title }}</span>
          </el-form-item>
          <el-form-item v-if="profile.activity_params.starttime" label="活动时间">
            <span>{{ profile.activity_params.starttime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }} 至 {{ profile.activity_params.endtime | parseTime('{y}/{m}/{d} {h}:{i}:{s}') }}</span>
            <span v-if="activity_status == '未开始'" class="beforeStart ml-lg">{{ activity_status }}</span>
            <span v-if="activity_status == '进行中'" class="starting ml-lg">{{ activity_status }}</span>
            <span v-if="activity_status == '已结束'" class="afterStart ml-lg">{{ activity_status }}</span>
          </el-form-item>
          <el-form-item label="促销价格">
            <span
              v-if="profile.activity_params.advanced_price_enable&&profile.scheme_unit === 'year'&& profile.activity_params.advanced_prices!= (undefined && null)"
            >一年总价 {{ profile.activity_params.advanced_prices.one_year | currency }}；两年总价 {{ profile.activity_params.advanced_prices.two_year * 2 | currency }}；三年总价 {{ profile.activity_params.advanced_prices.three_year * 3 | currency }}</span>
            <span v-else>
              <!-- {{ profile.activity_params.discount_price | currency }} -->
              一年总价 {{ profile.activity_params.discount_price | currency }}；两年总价 {{ profile.activity_params.discount_price * 2 | currency }}；三年总价 {{ profile.activity_params.discount_price * 3 | currency }}
            </span>
          </el-form-item>
        </el-form>
      </el-form-item>
    </el-form>
    <el-form v-show="postFormShow" ref="postForm" label-position="left" label-width="120px" :model="formData" :rules="formRules">
      <el-form-item label="方案类型" prop="scheme_unit">
        <el-radio-group v-model="formData.scheme_unit" @change="changeBasic">
          <el-radio :label="'year'">年收费方案</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="方案名称" prop="title">
        <el-col :span="17">
          <el-input v-model="formData.title" placeholder="请填写方案名称" @input="changeBasic" />
        </el-col>
      </el-form-item>
      <el-form-item prop="scheme_price">
        <span slot="label">
          <span class="mr-xs">收费标准</span>
          <el-tooltip placement="top" popper-class="price_tooltip">
            <span slot="content">
              请注意，该收费标准将作为定价参考，实际售价还受商户促销、平台营销，以及是否涉及物联卡保号复机等因素影响。最终收费标准，以下单时页面展示为准。
            </span>
            <i class="iconfont icon-circle-question" style="font-size: 14px;color: #999;"></i>
          </el-tooltip>
        </span>
        <el-col :span="17">
          <el-input v-model.trim="formData.scheme_price" placeholder="请填写收费金额，金额应为大于零的正整数" @input="changeBasic" />
        </el-col>
      </el-form-item>
      <el-form-item label="活动促销">
        <el-col :span="17">
          <el-switch v-model="activity_enable" active-color="#07c160" inactive-color="#a1a1a2" @change="changeBasic"></el-switch>
        </el-col>
      </el-form-item>
      <div class="activityOptions" v-if="activity_enable">
        <el-form-item label="活动名称" prop="name">
          <el-col :span="14">
            <el-input v-model="formData.name" @input="changeBasic" placeholder="请输入活动名称，“双十一专享活动”" :minlength="1" :maxlength="10" show-word-limit style="width: 350px;"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="活动时间" prop="activityTime">
          <el-col :span="18">
            <f-date-range-picker v-model="formData.activityTime" @change="changeBasic" style="width: 350px;"></f-date-range-picker>
            <span class="ml-md">
              <span v-if="status == '未开始'" class="beforeStart ml">{{ status }}</span>
              <span v-if="status == '进行中'" class="starting ml">{{ status }}</span>
              <span v-if="status == '已结束'" class="afterStart ml">{{ status }}</span>
            </span>
          </el-col>

        </el-form-item>
        <el-form-item label="促销价格" prop="discount_price" :class="advanced_price_enable&&'last'">
          <el-checkbox
            v-if="advanced_price_enable && formData.scheme_unit == 'year'"
            label="阶梯价"
            v-model="advanced_price_enable"
            @change="changeBasic"
          ></el-checkbox>
          <div :class="advanced_price_enable ? 'error' : ''">
            <el-col v-if="!advanced_price_enable" :span="14">
              <el-input v-model.trim="formData.discount_price" placeholder="请输入促销价格" @input="changeBasic" />
            </el-col>
            <el-col v-show="formData.discount_price && !advanced_price_enable" :span="8">
              <span class="ml">{{ discount1 }}</span>
            </el-col>
          </div>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-if="!advanced_price_enable && formData.scheme_unit == 'year'"
            label="阶梯价"
            v-model="advanced_price_enable"
            @change="changeBasic"
          ></el-checkbox>
        </el-form-item>
        <template>
          <div v-if="advanced_price_enable" class="discount">
            <el-form-item prop="discount_price">
              <el-col :span="18">
                <el-input placeholder="请输入促销价格" v-model.trim="formData.discount_price" @input="changeBasic" class="input-year" style="width: 350px;">
                  <template slot="prepend">一年总价</template>
                </el-input>
                <span v-show="formData.discount_price" class="ml-md">
                  <span class="ml">{{ discount1 }}</span>
                  <span v-if="formData.discount_price" class="ml">￥{{ formData.discount_price }}/年</span>
                </span>
              </el-col>

            </el-form-item>
            <el-form-item prop="two_year_total">
              <el-col :span="18">
                <el-input placeholder="请输入促销价格" v-model.trim="formData.two_year_total" @input="changeBasic" class="input-year" style="width: 350px;">
                  <template slot="prepend">两年总价</template>
                </el-input>
                <span v-show="two_year" class="ml-md">
                  <span class="ml">{{ discount2 }}</span>
                  <span v-if="two_year" class="ml">￥{{ two_year }}/年</span>
                </span>
              </el-col>

            </el-form-item>
            <el-form-item prop="three_year_total">
              <el-col :span="18">
                <el-input placeholder="请输入促销价格" v-model.trim="formData.three_year_total" @input="changeBasic" class="input-year" style="width: 350px;">
                  <template slot="prepend">三年总价</template>
                </el-input>
                <span v-show="three_year" class="ml-md">
                  <span class="ml">{{ discount3 }}</span>
                  <span v-if="three_year" class="ml">￥{{ three_year }}/年</span>
                </span>
              </el-col>

            </el-form-item>
          </div>
        </template>
      </div>
      <el-form-item>
        <el-button type="primary" :loading="postLoading" @click="confirmSubmit">提 交</el-button>
        <el-button @click="changeBack">返 回</el-button>
      </el-form-item>
    </el-form>

    <clause v-if="clause_show" :show.sync="clause_show" :plat_promotion_enable="profile.plat_promotion_enable" @submit="handleSubmit" />
  </div>
</template>

<script>
import { getSchemeDetailApi, postSchemeApi } from "@/api/ei/eiApi";

export default {
  name: "EiSchemeBasic",

  components: {
    Clause: () => import("./EiClause")
  },

  props: {
    type: {
      type: Number,
      default: undefined,
    },

    plat_promotion_enable: {
      type: [Boolean, Number],
      default: false,
    },

    recommendProfile: {
      type: Object,
      default: () => ({}),
    }
  },

  data() {
    var checkFloat = (rule, value, callback) => {
      const val = value.toString();
      if (!val.trim()) {
        callback(new Error("收费金额不能为空"));
      } else if (isNaN(value)) {
        return callback(new Error("请输入数字"));
      } else if (value < 0 || value == 0) {
        return callback(new Error("金额必须大于零"));
      } else if (val.indexOf(".") != -1 && val.split(".")[1].length > 2) {
        callback(new Error("最多输入两位小数"));
      } else {
        callback();
      }
    };
    let limitNumber = (rule, value, callback) => {
      const field = rule.field;
      const temp1 = Number(this.formData.discount_price);
      const scheme_price = Number(this.formData.scheme_price);
      const temp2 = Number(this.formData.two_year_total);
      const temp3 = Number(this.formData.three_year_total);
      const describle = this.advanced_price_enable
        ? field == "discount_price"
          ? "一年促销单价"
          : field == "two_year_total"
          ? "两年促销单价"
          : field == "three_year_total"
          ? "三年促销单价"
          : "促销单价"
        : "促销单价";

      const val = value.toString();
      if (isNaN(value)) {
        callback(new Error("只允许输入数字"));
        return;
      }
      if (val.trim() <= 0) {
        callback(new Error("单价必须大于0"));
        return;
      }
      if (val.indexOf(".") != -1 && val.split(".")[1].length > 2) {
        callback(new Error("最多输入两位小数"));
        return;
      }
      if (field == "discount_price" && value && value > scheme_price) {
        callback(new Error(describle + "不能超过收费金额"));
        return;
      }
      if (field == "two_year_total" && value && value / 2 > scheme_price) {
        callback(new Error(describle + "不能超过收费金额"));
        return;
      }
      if (field == "three_year_total" && value && value / 3 > scheme_price) {
        callback(new Error(describle + "不能超过收费金额"));
        return;
      }
      if (field == "two_year_total" && temp2 && temp2 / 2 > temp1) {
        callback(new Error("两年促销单价不能超过一年促销单价"));
        return;
      }
      if (field == "three_year_total" && temp3 && temp3 / 3 > temp2 / 2) {
        callback(new Error("三年促销单价不能超过两年促销单价"));
        return;
      }
      callback();
    };
    let limitTime = (rule, value, callback) => {
      if (value[0] == undefined || value[1] == undefined) {
        callback(new Error("活动时间不能为空"));
      } else {
        callback();
      }
    };

    return {
      resSchemeid: null,
      postLoading: false,
      postFormShow: false,
      activity_enable: 0,
      advanced_price_enable: 0,
      status: null,
      schemeid: this.$route.query.schemeid
        ? parseInt(this.$route.query.schemeid)
        : undefined,
      profile: {
        title: "",
        unit: null,
        price: 0,
        activity_enable: 0,
        plat_promotion_enable: 1,
        activity_params: {
          advanced_prices: {},
        },
      },
      backup: {
        title: "",
        unit: null,
        price: 0,
        activity_enable: 0,
        activity_params: {
          advanced_prices: {},
        },
      },
      loading: false,
      formData: {
        title: "",
        scheme_unit: "year",
        scheme_price: "",
      },
      formRules: {
        title: [
          { required: true, message: "方案名称不能为空", trigger: "blur" },
        ],
        scheme_unit: [
          { required: true, message: "方案类型不能为空", trigger: "blur" },
        ],
        scheme_price: [
          { required: true, message: "收费金额不能为空", trigger: "blur" },
          { validator: checkFloat, trigger: "blur" },
        ],
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        activityTime: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
          { validator: limitTime, trigger: "blur" },
        ],
        discount_price: [
          { required: true, message: "请输入促销价格", trigger: "blur" },
          { validator: limitNumber, trigger: "blur" },
        ],
        two_year_total: [
          { required: true, message: "请输入促销价格", trigger: "blur" },
          { validator: limitNumber, trigger: "blur" },
        ],
        three_year_total: [
          { required: true, message: "请输入促销价格", trigger: "blur" },
          { validator: limitNumber, trigger: "blur" },
        ],
      },

      clause_show: false,
    };
  },

  computed: {
    superFastLogin() {
      return this.$store.state.userStore.superFastLogin;
    },

    aiot_version() {
      return this.$store.state.godStore.aiot_version;
    },

    discount1() {
      if (this.formData.discount_price && this.formData.scheme_price) {
        const temp = (
          (Number(this.formData.discount_price) / this.formData.scheme_price) *
          10
        ).toFixed(1);
        if (temp && temp != "NaN" && temp.trim() != 0) return temp + "折";
      }
    },

    discount2() {
      if (this.formData.two_year_total && this.formData.scheme_price) {
        const temp = (
          (Number(this.formData.two_year_total) / 2 / this.formData.scheme_price) *
          10
        ).toFixed(1);
        if (temp && temp != "NaN" && temp.trim() != 0) return temp + "折";
      }
    },

    discount3() {
      if (this.formData.three_year_total && this.formData.scheme_price) {
        const temp = (
          (Number(this.formData.three_year_total) / 3 / this.formData.scheme_price) *
          10
        ).toFixed(1);
        if (temp && temp != "NaN" && temp.trim() != 0) return temp + "折";
      }
    },

    two_year() {
      if (this.formData.two_year_total) {
        return +(this.formData.two_year_total / 2 ).toFixed(4);
      } else {
        return 0
      }
    },

    three_year() {
      if (this.formData.three_year_total) {
        return +(this.formData.three_year_total / 3 ).toFixed(4);
      } else {
        return 0
      }
    },

    activity_status() {
      const today = new Date().valueOf();
      const temp = parseInt(today / 1000);
      if (
        this.profile.activity_params.starttime &&
        temp < this.profile.activity_params.starttime
      ) {
        return "未开始";
      } else if (
        this.profile.activity_params.endtime &&
        temp > this.profile.activity_params.endtime
      ) {
        return "已结束";
      } else {
        return "进行中";
      }
    },
  },

  watch: {
    recommendProfile(newVal, oldVal){
      // 设置活动时间
      const currentYear = new Date().getFullYear();
      const activityTime = [
        new Date(currentYear, 0, 1, 0, 0, 0).getTime() / 1000,
        new Date(currentYear + 10, 11, 31, 23, 59, 59).getTime() / 1000,
      ];

      this.formData = Object.assign({},this.formData, newVal,{
        name: newVal.activity_params.title,
        discount_price: newVal.activity_params.discount_price,
        activityTime,
        discount_price: newVal.activity_params.discount_price,
        two_year_total: +(newVal.activity_params.advanced_prices.two_year * 2).toFixed(2),
        three_year_total: +(newVal.activity_params.advanced_prices.three_year * 3).toFixed(2),
      })
      this.activity_enable = newVal.activity_enable ? true : false
      this.advanced_price_enable = newVal.activity_params.advanced_price_enable ? true : false
      this.status = '进行中'
    }
  },

  created() {
    this.fetchData();
    if(this.schemeid == 0) {
      this.profile.plat_promotion_enable = Object.assign({},this.profile,{plat_promotion_enable: this.plat_promotion_enable})
    }
  },
  methods: {
    fetchData() {
      if (!this.schemeid) {
        this.postFormShow = true;
        this.changeBasic();
        return;
      }
      this.loading = true;
      getSchemeDetailApi({ schemeid: this.schemeid }).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.profile = Object.assign({}, res.data.profile);
          this.backup = Object.assign({}, res.data.profile);
          if (this.profile.activity_params.discount_price == 0) {
            this.profile.activity_params.discount_price = null;
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },

    setScheme() {
      const godId = this.$store.state.godStore.godid
      if (!this.superFastLogin && this.aiot_version == 2 && godId !== 1) {
        this.$alert('合作版暂不支持该操作！', '提示', {
          type: 'warning'
        })
        return
      }
      this.clause_show = true;
    },

    handleSubmit(e) {
      this.profile.plat_promotion_enable = e.plat_promotion_enable
      this.onPostFormClick(e.plat_promotion_enable)
    },

    async onPostFormClick(plat_promotion_enable) {
      this.postFormShow = true;
      if (this.resSchemeid != null) {
        let res = await getSchemeDetailApi({ schemeid: this.resSchemeid });
        if (!res.errno) {
          this.profile = Object.assign({}, res.data.profile, {plat_promotion_enable});
          this.backup = Object.assign({}, res.data.profile, {plat_promotion_enable});

          if (this.profile.activity_params.discount_price == 0) {
            this.profile.activity_params.discount_price = null;
          }
        }
      }
      if (!this.profile.activity_enable) {
        this.formData = {
          title: this.profile.title,
          scheme_unit: this.profile.scheme_unit,
          scheme_price: this.profile.scheme_price,
        };
      } else if (this.profile.activity_params.advanced_price_enable) {
        this.advanced_price_enable = true;
        this.formData = {
          title: this.profile.title,
          scheme_unit: this.profile.scheme_unit,
          scheme_price: this.profile.scheme_price,
          activityTime: [
            this.profile.activity_params.starttime,
            this.profile.activity_params.endtime,
          ],
          name: this.profile.activity_params.title,
          discount_price: this.profile.activity_params.discount_price,
          // two_year: this.profile.activity_params.advanced_prices.two_year,
          two_year_total: +(this.profile.activity_params.advanced_prices.two_year * 2).toFixed(2),
          three_year_total: +(this.profile.activity_params.advanced_prices.three_year * 3).toFixed(2),
          // three_year: this.profile.activity_params.advanced_prices.three_year,
        };
      } else {
        this.formData = {
          title: this.profile.title,
          scheme_unit: this.profile.scheme_unit,
          scheme_price: this.profile.scheme_price,
          activityTime: [
            this.profile.activity_params.starttime,
            this.profile.activity_params.endtime,
          ],
          name: this.profile.activity_params.title,
          discount_price: this.profile.activity_params.discount_price,
        };
      }
      if (this.formData.activityTime) {
        const today = parseInt(new Date().valueOf() / 1000);
        const time = this.formData.activityTime;
        if (today < time[0]) {
          this.status = "未开始";
        } else if (today > time[1]) {
          this.status = "已结束";
        } else {
          this.status = "进行中";
        }
      } else {
        this.status = null;
      }
      this.activity_enable = this.profile.activity_enable ? true : false;

      this.$nextTick(() => {
        this.$refs["postForm"].clearValidate();
      });
      this.$emit("show", this.postFormShow);
    },

    confirmSubmit() {
      let message = "";
      if (+this.formData.scheme_price >= 200) {
        message = "当前方案单价超过¥200/年，定价过高，影响续费率，建议调整，是否继续？";
      } else if (!this.activity_enable) {
        message = "当前方案未开启促销活动，影响续费率，建议调整，是否继续？";
      }
      if (message) {
        this.$confirm(message, "提示", {
          type: "warning",
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确认提交",
          cancelButtonText: "返回调整",
        })
          .then(() => {
            this.onPostFormSubmit();
          })
          .catch(() => {});
      } else {
        this.onPostFormSubmit();
      }
    },

    onPostFormSubmit() {
      // const that = this;
      this.postLoading = true;
      const temp = {
        schemeid: this.schemeid,
        title: this.formData.title,
        unit: this.formData.scheme_unit,
        price: Number(this.formData.scheme_price),
        activity_enable: this.activity_enable ? 1 : 0,
        activity_params: {},
      };
      if(this.schemeid == 0) {
        temp.plat_promotion_enable = this.plat_promotion_enable ? 1 : 0
      } else {
        temp.plat_promotion_enable = this.profile.plat_promotion_enable ? 1 : 0
      }
      if (temp.activity_enable) {
        let activity_params = {
          title: this.formData.name ? this.formData.name : "",
          discount_price: Number(this.formData.discount_price)
            ? Number(this.formData.discount_price)
            : 0,
          starttime: this.formData.activityTime
            ? this.formData.activityTime[0]
            : null,
          endtime: this.formData.activityTime
            ? this.formData.activityTime[1]
            : null,
          advanced_price_enable: this.advanced_price_enable ? 1 : 0,
          advanced_prices: {},
        };
        if (activity_params.advanced_price_enable)
          activity_params.advanced_prices = {
            one_year: Number(this.formData.discount_price)
              ? Number(this.formData.discount_price)
              : 0,
            two_year: Number(this.two_year)
              ? Number(this.two_year)
              : 0,
            three_year: Number(this.three_year)
              ? Number(this.three_year)
              : 0,
          };
        temp.activity_params = activity_params;
      }
      this.$refs["postForm"].validate((valid) => {
        if (valid) {
          postSchemeApi(temp)
            .then((res) => {
              this.postLoading = false;
              if (!res.errno) {
                // 操作成功处理
                if (this.schemeid == 0) {
                  this.schemeid = res.data.schemeid;
                  this.$router.replace(
                    `/ei/scheme/detail?schemeid=${this.schemeid}`
                  );
                  this.$emit("update", this.schemeid);
                }
                this.resSchemeid = res.data.schemeid;
                this.schemeid = res.data.schemeid;
                this.postFormShow = false;
                this.fetchData();
                this.$emit("show", this.postFormShow);
                this.$message.success("方案设置成功！");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch(() => {});
        } else {
          this.postLoading = false;
        }
      });
    },
    changeBack() {
      if(!this.schemeid) {
        this.$router.go(-1);
        return
      }
      this.postFormShow = false;
      this.activity_enable = this.backup.activity_enable;
      this.profile.activity_enable = this.activity_enable;
      const temp = {
        title: this.backup.title,
        unit: this.backup.scheme_unit,
        scheme_price: this.backup.scheme_price,
        activity_enable: this.backup.activity_enable ? 1 : 0,
        name: this.backup.activity_params.title
          ? this.backup.activity_params.title
          : "",
        discount_price: this.backup.activity_params.discount_price
          ? this.backup.activity_params.discount_price
          : 0,
        advanced_price_enable: this.backup.activity_params.advanced_price_enable
          ? 1
          : 0,
        starttime: this.backup.activity_params.starttime
          ? this.backup.activity_params.starttime
          : null,
        endtime: this.backup.activity_params.endtime
          ? this.backup.activity_params.endtime
          : null,
      };
      var tempParam = temp;
      if (
        this.backup.scheme_unit == "year" &&
        this.backup.activity_params.advanced_price_enable
      ) {
        this.advanced_price_enable =
          this.backup.activity_params.advanced_price_enable;
        this.profile.activity_params.advanced_price_enable =
          this.advanced_price_enable;
        const temp2 = {
          one_year: this.backup.activity_params.advanced_prices.one_year
            ? this.backup.activity_params.advanced_prices.one_year
            : 0,
          two_year: this.backup.activity_params.advanced_prices.two_year
            ? this.backup.activity_params.advanced_prices.two_year
            : 0,
          three_year: this.backup.activity_params.advanced_prices.three_year
            ? this.backup.activity_params.advanced_prices.three_year
            : 0,
        };
        tempParam = Object.assign(temp, temp2);
      }
      this.$emit("change", tempParam);
      this.$emit("show", this.postFormShow);
      this.fetchData();
    },
    changeBasic() {
      if (this.formData.scheme_unit != "year") {
        this.advanced_price_enable = 0;
      }
      if (this.formData.activityTime) {
        const today = parseInt(new Date().valueOf() / 1000);
        const time = this.formData.activityTime;
        if (today < time[0]) {
          this.status = "未开始";
        } else if (today > time[1]) {
          this.status = "已结束";
        } else {
          this.status = "进行中";
        }
      } else {
        this.status = null;
      }
      if (!this.activity_enable) {
        this.advanced_price_enable = false;
      }
      this.profile.activity_enable = this.activity_enable;
      const temp = {
        title: this.formData.title,
        unit: this.formData.scheme_unit,
        scheme_price: this.formData.scheme_price,
        one_year: this.formData.discount_price
          ? this.formData.discount_price
          : 0,
        two_year: this.two_year ? this.two_year : 0,
        three_year: this.three_year ? this.three_year : 0,
        name: this.formData.name ? this.formData.name : "",
        activity_enable: this.activity_enable ? 1 : 0,
        discount_price: this.formData.discount_price
          ? this.formData.discount_price
          : 0,
        advanced_price_enable: this.advanced_price_enable ? 1 : 0,
        starttime: this.formData.activityTime
          ? this.formData.activityTime[0]
          : null,
        endtime: this.formData.activityTime
          ? this.formData.activityTime[1]
          : null,
      };
      this.$emit("change", temp);
    },
  },
};
</script>

<style lang="scss" slot-scoped>
.ei-scheme-basic {
  padding: 20px;
  .toolbox {
    display: flex;
    justify-content: flex-end;
  }
}
.el-form.display-form {
  .el-form-item:last-child.begin {
    .el-form-item__content {
      border-bottom: none;
      .el-form-item {
        margin-bottom: 22px;
        .el-form-item__content {
          border-bottom: 1px solid #ebeef5;
        }
      }
    }
  }
}
.beforeStart {
  color: red;
}
.starting {
  color: #07c160;
}
.afterStart {
  color: #909399;
}

.activityOptions {
  margin-left: 120px;
  .el-form-item {
    .error + .el-form-item__error {
      display: none;
    }
  }
  .el-form-item.last {
    margin-bottom: 0px;
  }
  .discount {
    .el-form-item {
      margin-bottom: 0px;
      .el-form-item__content {
        .el-input-group {
          margin-bottom: 25px;
        }
        .el-form-item__error {
          top: 60%;
        }
      }
    }
  }
}
.price_tooltip.el-tooltip__popper {
  width: 320px;
}
</style>
